import React, { Component } from 'react';
import config from 'react-global-configuration';

config.set({ url: 'https://controle.sigtrein.com.br', api: 'https://api.sigtrein.com.br/api', auth: 'https://api.sigtrein.com.br', cdn: 'https://cdn.sigtrein.com.br', refresh_time: 1});

class Globals extends Component {
}


export default Globals;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Globals.js